import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SignIn, SignUp } from "@clerk/react";
import { Toaster } from "./components/ui/sonner";
import { TooltipProvider } from "./components/ui/tooltip";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { LangProvider } from "./lib/i18n";
import { ConfigProvider } from "./lib/config";
import SiteLayout from "./components/site/SiteLayout";
import Home from "./pages/Home";
import { About, Services, Pricing, FAQ, Contact, MyBookings } from "./pages/Static";
import Book from "./pages/Book";
import { Quote, BookingView, QuoteView, PaymentResult } from "./pages/Flows";
import Account from "./pages/Account";
import AdminLayout from "./pages/admin/AdminLayout";
import { Bookings, Calendar } from "./pages/admin/AdminBookings";
import { Services as AdminServices, Coupons, Employees, PricingSettings } from "./pages/admin/AdminCatalog";
import { Overview, Customers, Quotes, Payments, Reports, Audit, Users, Messages, MyJobs } from "./pages/admin/AdminMisc";

const AuthPage = ({ children }) => <div className="min-h-screen bg-sky-50 flex flex-col items-center justify-center gap-6 p-4"><a href="/"><img src="/images/logo.png" alt="Mainliz Cleaning Services" className="h-20 w-auto" data-testid="auth-logo" /></a>{children}</div>;

function App() {
  return (
    <LangProvider>
      <ConfigProvider>
        <BrowserRouter>
          <ClerkAuthProvider>
            <TooltipProvider delayDuration={150}>
            <Routes>
              <Route element={<SiteLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/book" element={<Book />} />
                <Route path="/quote" element={<Quote />} />
                <Route path="/quote/:id" element={<QuoteView />} />
                <Route path="/booking/:id" element={<BookingView />} />
                <Route path="/my-bookings" element={<MyBookings />} />
                <Route path="/account" element={<Account />} />
                <Route path="/payment/success" element={<PaymentResult />} />
                <Route path="/payment/cancel" element={<PaymentResult cancelled />} />
              </Route>
              <Route path="/sign-in/*" element={<AuthPage><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></AuthPage>} />
              <Route path="/sign-up/*" element={<AuthPage><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthPage>} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Overview />} />
                <Route path="calendar" element={<Calendar />} />
                <Route path="bookings" element={<Bookings />} />
                <Route path="customers" element={<Customers />} />
                <Route path="quotes" element={<Quotes />} />
                <Route path="employees" element={<Employees />} />
                <Route path="messages" element={<Messages />} />
                <Route path="services" element={<AdminServices />} />
                <Route path="pricing" element={<PricingSettings />} />
                <Route path="coupons" element={<Coupons />} />
                <Route path="payments" element={<Payments />} />
                <Route path="reports" element={<Reports />} />
                <Route path="audit" element={<Audit />} />
                <Route path="users" element={<Users />} />
                <Route path="my-jobs" element={<MyJobs />} />
                <Route path="new-booking" element={<Book admin />} />
              </Route>
            </Routes>
            </TooltipProvider>
          </ClerkAuthProvider>
        </BrowserRouter>
        <Toaster richColors position="top-center" />
      </ConfigProvider>
    </LangProvider>
  );
}

export default App;
